import AboutButton from './AboutButton';
import AboutModal from './AboutModal';
export default { AboutButton, AboutModal };
